import React from "react";
import { useTranslation } from "react-i18next";
import "./AboutUsSection4.css";
import BirdImage from "../../../assets/Logos/2/colored.svg";
import AboutUsDivider from "../AboutUsDivider/AboutUsDivider";
import { Link, useParams } from "react-router-dom";

const AboutUsSection4 = () => {
  const { t } = useTranslation();
  const { lang } = useParams();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section
      className="about-us-section4"
      aria-labelledby="join-journey-heading"
    >
      <AboutUsDivider heading={t("aboutUsSection4.heading")} />
      <section className="join-our-journey">
        <div className="journey-container">
          <article className="journey-content">
            <h2 id="join-journey-heading" className="journey-title">
              {t("aboutUsSection4.title")}
            </h2>
            <p className="journey-description">
              {t("aboutUsSection4.description")}
            </p>
            <div className="journey-buttons">
              <Link
                to={`/${lang}/OurServices`}
                onClick={scrollToTop}
                className="journey-button"
                aria-label="Discover our services"
              >
                {t("aboutUsSection4.discoverServicesButton")}
              </Link>
              <Link
                to={`/${lang}/JoinUs`}
                onClick={scrollToTop}
                className="journey-button outlined"
                aria-label="Join our team"
              >
                {t("aboutUsSection4.joinTeamButton")}
              </Link>
            </div>
          </article>
          <figure className="journey-image">
            <img
              src={BirdImage}
              alt="Team collaborating"
              loading="lazy"
              width="400"
              height="300"
              title="Virtue Team"
            />
          </figure>
        </div>
      </section>
    </section>
  );
};

export default AboutUsSection4;
